module.exports = __webpack_public_path__ + "img/38.14b15b6e.png";